import cjPontanegraApi from '../apis/cjPontanegraApi';

export const deleteAdvertisementCategoriesService = async (
  categoryId: string,
): Promise<void> => {
  await cjPontanegraApi.delete(`/announcements/categories/${categoryId}`);
};
